import { render, staticRenderFns } from "./VietLV1.vue?vue&type=template&id=a96d1afc&scoped=true"
import script from "./VietLV1.vue?vue&type=script&lang=js"
export * from "./VietLV1.vue?vue&type=script&lang=js"
import style0 from "./VietLV1.vue?vue&type=style&index=0&id=a96d1afc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96d1afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a96d1afc')) {
      api.createRecord('a96d1afc', component.options)
    } else {
      api.reload('a96d1afc', component.options)
    }
    module.hot.accept("./VietLV1.vue?vue&type=template&id=a96d1afc&scoped=true", function () {
      api.rerender('a96d1afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/VietLV1.vue"
export default component.exports